module.exports = __webpack_public_path__ + "static/media/1.4cf2d266.png";